'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _connectField = require('uniforms/connectField');

var _connectField2 = _interopRequireDefault(_connectField);

var _filterDOMProps = require('uniforms/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

var _joinName = require('uniforms/joinName');

var _joinName2 = _interopRequireDefault(_joinName);

var _ListAddField = require('./ListAddField');

var _ListAddField2 = _interopRequireDefault(_ListAddField);

var _ListItemField = require('./ListItemField');

var _ListItemField2 = _interopRequireDefault(_ListItemField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function List(_ref) {
    var addIcon = _ref.addIcon,
        children = _ref.children,
        className = _ref.className,
        error = _ref.error,
        errorMessage = _ref.errorMessage,
        initialCount = _ref.initialCount,
        itemProps = _ref.itemProps,
        label = _ref.label,
        name = _ref.name,
        removeIcon = _ref.removeIcon,
        showInlineError = _ref.showInlineError,
        value = _ref.value,
        props = (0, _objectWithoutProperties3.default)(_ref, ['addIcon', 'children', 'className', 'error', 'errorMessage', 'initialCount', 'itemProps', 'label', 'name', 'removeIcon', 'showInlineError', 'value']);
    return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ className: (0, _classnames2.default)('card', className) }, (0, _filterDOMProps2.default)(props)),
        _react2.default.createElement(
            'div',
            { className: 'card-block' },
            label && _react2.default.createElement(
                'div',
                { className: 'card-title' },
                _react2.default.createElement(
                    'label',
                    { className: 'control-label' },
                    label,
                    '\xA0'
                ),
                _react2.default.createElement(_ListAddField2.default, { name: name + '.$', initialCount: initialCount, addIcon: addIcon }),
                !!(error && showInlineError) && _react2.default.createElement(
                    'span',
                    { className: 'text-danger' },
                    errorMessage
                )
            ),
            children ? value.map(function (item, index) {
                return _react.Children.map(children, function (child) {
                    return _react2.default.cloneElement(child, {
                        key: index,
                        label: null,
                        name: (0, _joinName2.default)(name, child.props.name && child.props.name.replace('$', index)),
                        removeIcon: removeIcon
                    });
                });
            }) : value.map(function (item, index) {
                return _react2.default.createElement(_ListItemField2.default, (0, _extends3.default)({
                    key: index,
                    label: null,
                    name: (0, _joinName2.default)(name, index),
                    removeIcon: removeIcon
                }, itemProps));
            })
        )
    );
};

exports.default = (0, _connectField2.default)(List, { includeInChain: false });


//////////////////
// WEBPACK FOOTER
// ./~/uniforms-bootstrap4/ListField.js
// module id = 468
// module chunks = 0